import type { ReactNode } from 'react';

import BpkModal from '@skyscanner/backpack-web/bpk-component-modal';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { withI18n } from '../../contexts/i18n';

import ModalLayout from './ModalLayout';

import type { I18nService } from '@shared/types/i18n';
import type { Maybe } from '@shared/types/utils';

import STYLES from './SemiModal.module.scss';

import { getApplicationElement } from '@shared/utils-frontend/ApplicationElements';

type Props = {
  i18n: I18nService;
  id: string;
  children: ReactNode;
  className?: Maybe<string>;
  href?: Maybe<string>;
  title?: ReactNode;
  onClose?: Maybe<Function>;
  footerClassName?: Maybe<string>;
  headerClassName?: Maybe<string>;
  footer?: ReactNode | ((onClick: Function) => ReactNode);
  header?: ReactNode;
  clearBtn?: ReactNode;
  divideFooter?: boolean;
  isOpen: boolean;
  padded?: boolean;
  enableScrollDivider?: boolean;
  withoutPadding?: boolean;
  noBottomPaddingBeyondFooter?: boolean;
};

const cls = cssModules(STYLES);

const SemiModal = ({
  children,
  className,
  clearBtn,
  divideFooter,
  enableScrollDivider,
  footer,
  footerClassName,
  header,
  headerClassName,
  href,
  i18n,
  id,
  isOpen,
  noBottomPaddingBeyondFooter,
  onClose,
  title,
  withoutPadding,
  ...rest
}: Props) => (
  <BpkModal
    {...rest}
    id={id}
    isOpen={isOpen}
    onClose={() => {}}
    showHeader={false}
    isIphone={false}
    closeOnScrimClick
    closeOnEscPressed
    fullScreenOnMobile={false}
    closeLabel={i18n.translate('Modal_close')}
    getApplicationElement={getApplicationElement}
    className={cls('SemiModal', className)}
    contentClassName={cls('SemiModal__modalContent')}
    padded={false}
  >
    <ModalLayout
      id={id}
      href={href}
      onClose={onClose}
      title={title}
      withoutPadding={withoutPadding}
      footerClassName={footerClassName}
      headerClassName={headerClassName}
      footer={footer}
      header={header}
      clearBtn={clearBtn}
      divideFooter={divideFooter}
      enableScrollDivider={enableScrollDivider}
      noBottomPaddingBeyondFooter={noBottomPaddingBeyondFooter}
    >
      {children}
    </ModalLayout>
  </BpkModal>
);

export default withI18n(SemiModal);
